module.exports = __webpack_public_path__ + "img/main-01-11.3c67edd5.png";